export interface InputState {
  value: string;
}

export enum InputType {
  Text = `text`,
  Password = `password`,
  Number = `number`,
  TextArea = `textarea`,
}

export enum InputSize {
  Medium = `medium`,
  Large = `large`,
}

export enum Necessary {
  Default = ``,
  Optional = `optional`,
  Required = `required`,
}

export enum ValidationStatus {
  Default = ``,
  Valid = `valid`,
  Invalid = `invalid`,
}

export type InputChangeEvent = CustomEvent<{
  value: string;
}>;

export enum TextAlign {
  Start = `start`,
  Center = `center`,
  End = `end`,
}
